import { Table } from "components";
import { ProfileTableHeaders } from "./components/ProfileTableHeadings";
import { ProfileTableData } from "./components/ProfileTableData";

export const ProfileTable = () => (
  <Table className="h-full" scrollClassName="mt-0" headings={<ProfileTableHeaders />} data={<ProfileTableData />} />
);
